import { OptionKeyAccessors } from '../components/common/Multiselect/types';

/**
 * Utility to get a nested property value by key path (e.g., "user.name")
 */
const getNestedValue = (obj: unknown, path: string): string => {
  const keys = path.split('.');
  const value = keys.reduce<unknown>((current, key) => {
    if (current === undefined || current === null) {
      return null;
    }
    return (current as Record<string, unknown>)?.[key];
  }, obj);

  if (value === undefined || value === null) {
    return '';
  }
  return String(value);
};

/**
 * Creates accessor functions from key strings
 */
export const createAccessors = ({
  identifierKey,
  labelKey,
  secondaryKey,
}: OptionKeyAccessors): {
  getOptionValue: (option: unknown) => string;
  getOptionLabel: (option: unknown) => string;
  getOptionSecondaryText?: (option: unknown) => string | undefined;
} => {
  return {
    getOptionValue: (option: unknown) => {
      // Use provided key or fallback to common patterns
      if (identifierKey) {
        return getNestedValue(option, identifierKey);
      }
      const obj = option as Record<string, unknown>;
      return String(obj.value || obj.id || '');
    },
    getOptionLabel: (option: unknown) => {
      // Use provided key or fallback to common patterns
      if (labelKey) {
        return getNestedValue(option, labelKey);
      }
      const obj = option as Record<string, unknown>;
      return String(obj.label || obj.name || '');
    },
    getOptionSecondaryText: secondaryKey
      ? (option: unknown) => {
          const value = getNestedValue(option, secondaryKey);
          return value || undefined;
        }
      : undefined,
  };
};
